export default __webpack_public_path__ + "static/media/chasing-dots.a280df8a.less";